module.exports = __webpack_public_path__ + "img/sdg_pt-pt_(1).d55e36ed.png";